export default {
  AF: {
    continent: 'Asia',
    id: 'AF',
    name: 'Afghanistan',
    population: 34124811,
    population_rank: 15,
    region: 'Southern Asia',
  },
  AO: {
    continent: 'Africa',
    id: 'AO',
    name: 'Angola',
    population: 29310273,
    population_rank: 15,
    region: 'Middle Africa',
  },
  AL: {
    continent: 'Europe',
    id: 'AL',
    name: 'Albania',
    population: 3047987,
    population_rank: 12,
    region: 'Southern Europe',
  },
  AE: {
    continent: 'Asia',
    id: 'AE',
    name: 'United Arab Emirates',
    population: 6072475,
    population_rank: 13,
    region: 'Western Asia',
  },
  AR: {
    continent: 'South America',
    id: 'AR',
    name: 'Argentina',
    population: 44293293,
    population_rank: 15,
    region: 'South America',
  },
  AM: {
    continent: 'Asia',
    id: 'AM',
    name: 'Armenia',
    population: 3045191,
    population_rank: 12,
    region: 'Western Asia',
  },
  AQ: {
    continent: 'Antarctica',
    id: 'AQ',
    name: 'Antarctica',
    population: 4050,
    population_rank: 4,
    region: 'Antarctica',
  },
  TF: {
    continent: 'Seven seas (open ocean)',
    id: 'TF',
    name: 'Fr. S. Antarctic Lands',
    population: 140,
    population_rank: 1,
    region: 'Seven seas (open ocean)',
  },
  AU: {
    continent: 'Oceania',
    id: 'AU',
    name: 'Australia',
    population: 23232413,
    population_rank: 15,
    region: 'Australia and New Zealand',
  },
  AT: {
    continent: 'Europe',
    id: 'AT',
    name: 'Austria',
    population: 8754413,
    population_rank: 13,
    region: 'Western Europe',
  },
  AZ: {
    continent: 'Asia',
    id: 'AZ',
    name: 'Azerbaijan',
    population: 9961396,
    population_rank: 13,
    region: 'Western Asia',
  },
  BI: {
    continent: 'Africa',
    id: 'BI',
    name: 'Burundi',
    population: 11466756,
    population_rank: 14,
    region: 'Eastern Africa',
  },
  BE: {
    continent: 'Europe',
    id: 'BE',
    name: 'Belgium',
    population: 11491346,
    population_rank: 14,
    region: 'Western Europe',
  },
  BJ: {
    continent: 'Africa',
    id: 'BJ',
    name: 'Benin',
    population: 11038805,
    population_rank: 14,
    region: 'Western Africa',
  },
  BF: {
    continent: 'Africa',
    id: 'BF',
    name: 'Burkina Faso',
    population: 20107509,
    population_rank: 15,
    region: 'Western Africa',
  },
  BD: {
    continent: 'Asia',
    id: 'BD',
    name: 'Bangladesh',
    population: 157826578,
    population_rank: 17,
    region: 'Southern Asia',
  },
  BG: {
    continent: 'Europe',
    id: 'BG',
    name: 'Bulgaria',
    population: 7101510,
    population_rank: 13,
    region: 'Eastern Europe',
  },
  BS: {
    continent: 'North America',
    id: 'BS',
    name: 'Bahamas',
    population: 329988,
    population_rank: 10,
    region: 'Caribbean',
  },
  BA: {
    continent: 'Europe',
    id: 'BA',
    name: 'Bosnia and Herz.',
    population: 3856181,
    population_rank: 12,
    region: 'Southern Europe',
  },
  BY: {
    continent: 'Europe',
    id: 'BY',
    name: 'Belarus',
    population: 9549747,
    population_rank: 13,
    region: 'Eastern Europe',
  },
  BZ: {
    continent: 'North America',
    id: 'BZ',
    name: 'Belize',
    population: 360346,
    population_rank: 10,
    region: 'Central America',
  },
  BO: {
    continent: 'South America',
    id: 'BO',
    name: 'Bolivia',
    population: 11138234,
    population_rank: 14,
    region: 'South America',
  },
  BR: {
    continent: 'South America',
    id: 'BR',
    name: 'Brazil',
    population: 207353391,
    population_rank: 17,
    region: 'South America',
  },
  BN: {
    continent: 'Asia',
    id: 'BN',
    name: 'Brunei',
    population: 443593,
    population_rank: 10,
    region: 'South-Eastern Asia',
  },
  BT: {
    continent: 'Asia',
    id: 'BT',
    name: 'Bhutan',
    population: 758288,
    population_rank: 11,
    region: 'Southern Asia',
  },
  BW: {
    continent: 'Africa',
    id: 'BW',
    name: 'Botswana',
    population: 2214858,
    population_rank: 12,
    region: 'Southern Africa',
  },
  CF: {
    continent: 'Africa',
    id: 'CF',
    name: 'Central African Rep.',
    population: 5625118,
    population_rank: 13,
    region: 'Middle Africa',
  },
  CA: {
    continent: 'North America',
    id: 'CA',
    name: 'Canada',
    population: 35623680,
    population_rank: 15,
    region: 'Northern America',
  },
  CH: {
    continent: 'Europe',
    id: 'CH',
    name: 'Switzerland',
    population: 8236303,
    population_rank: 13,
    region: 'Western Europe',
  },
  CL: {
    continent: 'South America',
    id: 'CL',
    name: 'Chile',
    population: 17789267,
    population_rank: 14,
    region: 'South America',
  },
  CN: {
    continent: 'Asia',
    id: 'CN',
    name: 'China',
    population: 1379302771,
    population_rank: 18,
    region: 'Eastern Asia',
  },
  CI: {
    continent: 'Africa',
    id: 'CI',
    name: "Côte d'Ivoire",
    population: 24184810,
    population_rank: 15,
    region: 'Western Africa',
  },
  CM: {
    continent: 'Africa',
    id: 'CM',
    name: 'Cameroon',
    population: 24994885,
    population_rank: 15,
    region: 'Middle Africa',
  },
  CD: {
    continent: 'Africa',
    id: 'CD',
    name: 'Dem. Rep. Congo',
    population: 83301151,
    population_rank: 16,
    region: 'Middle Africa',
  },
  CG: {
    continent: 'Africa',
    id: 'CG',
    name: 'Congo',
    population: 4954674,
    population_rank: 12,
    region: 'Middle Africa',
  },
  CO: {
    continent: 'South America',
    id: 'CO',
    name: 'Colombia',
    population: 47698524,
    population_rank: 15,
    region: 'South America',
  },
  CR: {
    continent: 'North America',
    id: 'CR',
    name: 'Costa Rica',
    population: 4930258,
    population_rank: 12,
    region: 'Central America',
  },
  CU: {
    continent: 'North America',
    id: 'CU',
    name: 'Cuba',
    population: 11147407,
    population_rank: 14,
    region: 'Caribbean',
  },
  '-99': {
    continent: 'Africa',
    id: '-99',
    name: 'Somaliland',
    population: 3500000,
    population_rank: 12,
    region: 'Eastern Africa',
  },
  CY: {
    continent: 'Asia',
    id: 'CY',
    name: 'Cyprus',
    population: 1221549,
    population_rank: 12,
    region: 'Western Asia',
  },
  CZ: {
    continent: 'Europe',
    id: 'CZ',
    name: 'Czechia',
    population: 10674723,
    population_rank: 14,
    region: 'Eastern Europe',
  },
  DE: {
    continent: 'Europe',
    id: 'DE',
    name: 'Germany',
    population: 80594017,
    population_rank: 16,
    region: 'Western Europe',
  },
  DJ: {
    continent: 'Africa',
    id: 'DJ',
    name: 'Djibouti',
    population: 865267,
    population_rank: 11,
    region: 'Eastern Africa',
  },
  DK: {
    continent: 'Europe',
    id: 'DK',
    name: 'Denmark',
    population: 5605948,
    population_rank: 13,
    region: 'Northern Europe',
  },
  DO: {
    continent: 'North America',
    id: 'DO',
    name: 'Dominican Rep.',
    population: 10734247,
    population_rank: 14,
    region: 'Caribbean',
  },
  DZ: {
    continent: 'Africa',
    id: 'DZ',
    name: 'Algeria',
    population: 40969443,
    population_rank: 15,
    region: 'Northern Africa',
  },
  EC: {
    continent: 'South America',
    id: 'EC',
    name: 'Ecuador',
    population: 16290913,
    population_rank: 14,
    region: 'South America',
  },
  EG: {
    continent: 'Africa',
    id: 'EG',
    name: 'Egypt',
    population: 97041072,
    population_rank: 16,
    region: 'Northern Africa',
  },
  ER: {
    continent: 'Africa',
    id: 'ER',
    name: 'Eritrea',
    population: 5918919,
    population_rank: 13,
    region: 'Eastern Africa',
  },
  ES: {
    continent: 'Europe',
    id: 'ES',
    name: 'Spain',
    population: 48958159,
    population_rank: 15,
    region: 'Southern Europe',
  },
  EE: {
    continent: 'Europe',
    id: 'EE',
    name: 'Estonia',
    population: 1251581,
    population_rank: 12,
    region: 'Northern Europe',
  },
  ET: {
    continent: 'Africa',
    id: 'ET',
    name: 'Ethiopia',
    population: 105350020,
    population_rank: 17,
    region: 'Eastern Africa',
  },
  FI: {
    continent: 'Europe',
    id: 'FI',
    name: 'Finland',
    population: 5491218,
    population_rank: 13,
    region: 'Northern Europe',
  },
  FJ: {
    continent: 'Oceania',
    id: 'FJ',
    name: 'Fiji',
    population: 920938,
    population_rank: 11,
    region: 'Melanesia',
  },
  FK: {
    continent: 'South America',
    id: 'FK',
    name: 'Falkland Is.',
    population: 2931,
    population_rank: 4,
    region: 'South America',
  },
  FR: {
    continent: 'Europe',
    id: 'FR',
    name: 'France',
    population: 67106161,
    population_rank: 16,
    region: 'Western Europe',
  },
  GA: {
    continent: 'Africa',
    id: 'GA',
    name: 'Gabon',
    population: 1772255,
    population_rank: 12,
    region: 'Middle Africa',
  },
  GB: {
    continent: 'Europe',
    id: 'GB',
    name: 'United Kingdom',
    population: 64769452,
    population_rank: 16,
    region: 'Northern Europe',
  },
  GE: {
    continent: 'Asia',
    id: 'GE',
    name: 'Georgia',
    population: 4926330,
    population_rank: 12,
    region: 'Western Asia',
  },
  GH: {
    continent: 'Africa',
    id: 'GH',
    name: 'Ghana',
    population: 27499924,
    population_rank: 15,
    region: 'Western Africa',
  },
  GN: {
    continent: 'Africa',
    id: 'GN',
    name: 'Guinea',
    population: 12413867,
    population_rank: 14,
    region: 'Western Africa',
  },
  GM: {
    continent: 'Africa',
    id: 'GM',
    name: 'Gambia',
    population: 2051363,
    population_rank: 12,
    region: 'Western Africa',
  },
  GW: {
    continent: 'Africa',
    id: 'GW',
    name: 'Guinea-Bissau',
    population: 1792338,
    population_rank: 12,
    region: 'Western Africa',
  },
  GQ: {
    continent: 'Africa',
    id: 'GQ',
    name: 'Eq. Guinea',
    population: 778358,
    population_rank: 11,
    region: 'Middle Africa',
  },
  GR: {
    continent: 'Europe',
    id: 'GR',
    name: 'Greece',
    population: 10768477,
    population_rank: 14,
    region: 'Southern Europe',
  },
  GL: {
    continent: 'North America',
    id: 'GL',
    name: 'Greenland',
    population: 57713,
    population_rank: 8,
    region: 'Northern America',
  },
  GT: {
    continent: 'North America',
    id: 'GT',
    name: 'Guatemala',
    population: 15460732,
    population_rank: 14,
    region: 'Central America',
  },
  GY: {
    continent: 'South America',
    id: 'GY',
    name: 'Guyana',
    population: 737718,
    population_rank: 11,
    region: 'South America',
  },
  HN: {
    continent: 'North America',
    id: 'HN',
    name: 'Honduras',
    population: 9038741,
    population_rank: 13,
    region: 'Central America',
  },
  HR: {
    continent: 'Europe',
    id: 'HR',
    name: 'Croatia',
    population: 4292095,
    population_rank: 12,
    region: 'Southern Europe',
  },
  HT: {
    continent: 'North America',
    id: 'HT',
    name: 'Haiti',
    population: 10646714,
    population_rank: 14,
    region: 'Caribbean',
  },
  HU: {
    continent: 'Europe',
    id: 'HU',
    name: 'Hungary',
    population: 9850845,
    population_rank: 13,
    region: 'Eastern Europe',
  },
  ID: {
    continent: 'Asia',
    id: 'ID',
    name: 'Indonesia',
    population: 260580739,
    population_rank: 17,
    region: 'South-Eastern Asia',
  },
  IN: {
    continent: 'Asia',
    id: 'IN',
    name: 'India',
    population: 1281935911,
    population_rank: 18,
    region: 'Southern Asia',
  },
  IE: {
    continent: 'Europe',
    id: 'IE',
    name: 'Ireland',
    population: 5011102,
    population_rank: 13,
    region: 'Northern Europe',
  },
  IR: {
    continent: 'Asia',
    id: 'IR',
    name: 'Iran',
    population: 82021564,
    population_rank: 16,
    region: 'Southern Asia',
  },
  IQ: {
    continent: 'Asia',
    id: 'IQ',
    name: 'Iraq',
    population: 39192111,
    population_rank: 15,
    region: 'Western Asia',
  },
  IS: {
    continent: 'Europe',
    id: 'IS',
    name: 'Iceland',
    population: 339747,
    population_rank: 10,
    region: 'Northern Europe',
  },
  IL: {
    continent: 'Asia',
    id: 'IL',
    name: 'Israel',
    population: 8299706,
    population_rank: 13,
    region: 'Western Asia',
  },
  IT: {
    continent: 'Europe',
    id: 'IT',
    name: 'Italy',
    population: 62137802,
    population_rank: 16,
    region: 'Southern Europe',
  },
  JM: {
    continent: 'North America',
    id: 'JM',
    name: 'Jamaica',
    population: 2990561,
    population_rank: 12,
    region: 'Caribbean',
  },
  JO: {
    continent: 'Asia',
    id: 'JO',
    name: 'Jordan',
    population: 10248069,
    population_rank: 14,
    region: 'Western Asia',
  },
  JP: {
    continent: 'Asia',
    id: 'JP',
    name: 'Japan',
    population: 126451398,
    population_rank: 17,
    region: 'Eastern Asia',
  },
  KZ: {
    continent: 'Asia',
    id: 'KZ',
    name: 'Kazakhstan',
    population: 18556698,
    population_rank: 14,
    region: 'Central Asia',
  },
  KE: {
    continent: 'Africa',
    id: 'KE',
    name: 'Kenya',
    population: 47615739,
    population_rank: 15,
    region: 'Eastern Africa',
  },
  KG: {
    continent: 'Asia',
    id: 'KG',
    name: 'Kyrgyzstan',
    population: 5789122,
    population_rank: 13,
    region: 'Central Asia',
  },
  KH: {
    continent: 'Asia',
    id: 'KH',
    name: 'Cambodia',
    population: 16204486,
    population_rank: 14,
    region: 'South-Eastern Asia',
  },
  KR: {
    continent: 'Asia',
    id: 'KR',
    name: 'South Korea',
    population: 51181299,
    population_rank: 16,
    region: 'Eastern Asia',
  },
  XK: {
    continent: 'Europe',
    id: 'XK',
    name: 'Kosovo',
    population: 1895250,
    population_rank: 12,
    region: 'Southern Europe',
  },
  KW: {
    continent: 'Asia',
    id: 'KW',
    name: 'Kuwait',
    population: 2875422,
    population_rank: 12,
    region: 'Western Asia',
  },
  LA: {
    continent: 'Asia',
    id: 'LA',
    name: 'Laos',
    population: 7126706,
    population_rank: 13,
    region: 'South-Eastern Asia',
  },
  LB: {
    continent: 'Asia',
    id: 'LB',
    name: 'Lebanon',
    population: 6229794,
    population_rank: 13,
    region: 'Western Asia',
  },
  LR: {
    continent: 'Africa',
    id: 'LR',
    name: 'Liberia',
    population: 4689021,
    population_rank: 12,
    region: 'Western Africa',
  },
  LY: {
    continent: 'Africa',
    id: 'LY',
    name: 'Libya',
    population: 6653210,
    population_rank: 13,
    region: 'Northern Africa',
  },
  LK: {
    continent: 'Asia',
    id: 'LK',
    name: 'Sri Lanka',
    population: 22409381,
    population_rank: 15,
    region: 'Southern Asia',
  },
  LS: {
    continent: 'Africa',
    id: 'LS',
    name: 'Lesotho',
    population: 1958042,
    population_rank: 12,
    region: 'Southern Africa',
  },
  LT: {
    continent: 'Europe',
    id: 'LT',
    name: 'Lithuania',
    population: 2823859,
    population_rank: 12,
    region: 'Northern Europe',
  },
  LU: {
    continent: 'Europe',
    id: 'LU',
    name: 'Luxembourg',
    population: 594130,
    population_rank: 11,
    region: 'Western Europe',
  },
  LV: {
    continent: 'Europe',
    id: 'LV',
    name: 'Latvia',
    population: 1944643,
    population_rank: 12,
    region: 'Northern Europe',
  },
  MA: {
    continent: 'Africa',
    id: 'MA',
    name: 'Morocco',
    population: 33986655,
    population_rank: 15,
    region: 'Northern Africa',
  },
  MD: {
    continent: 'Europe',
    id: 'MD',
    name: 'Moldova',
    population: 3474121,
    population_rank: 12,
    region: 'Eastern Europe',
  },
  MG: {
    continent: 'Africa',
    id: 'MG',
    name: 'Madagascar',
    population: 25054161,
    population_rank: 15,
    region: 'Eastern Africa',
  },
  MX: {
    continent: 'North America',
    id: 'MX',
    name: 'Mexico',
    population: 124574795,
    population_rank: 17,
    region: 'Central America',
  },
  MK: {
    continent: 'Europe',
    id: 'MK',
    name: 'Macedonia',
    population: 2103721,
    population_rank: 12,
    region: 'Southern Europe',
  },
  ML: {
    continent: 'Africa',
    id: 'ML',
    name: 'Mali',
    population: 17885245,
    population_rank: 14,
    region: 'Western Africa',
  },
  MM: {
    continent: 'Asia',
    id: 'MM',
    name: 'Myanmar',
    population: 55123814,
    population_rank: 16,
    region: 'South-Eastern Asia',
  },
  ME: {
    continent: 'Europe',
    id: 'ME',
    name: 'Montenegro',
    population: 642550,
    population_rank: 11,
    region: 'Southern Europe',
  },
  MN: {
    continent: 'Asia',
    id: 'MN',
    name: 'Mongolia',
    population: 3068243,
    population_rank: 12,
    region: 'Eastern Asia',
  },
  MZ: {
    continent: 'Africa',
    id: 'MZ',
    name: 'Mozambique',
    population: 26573706,
    population_rank: 15,
    region: 'Eastern Africa',
  },
  MR: {
    continent: 'Africa',
    id: 'MR',
    name: 'Mauritania',
    population: 3758571,
    population_rank: 12,
    region: 'Western Africa',
  },
  MW: {
    continent: 'Africa',
    id: 'MW',
    name: 'Malawi',
    population: 19196246,
    population_rank: 14,
    region: 'Eastern Africa',
  },
  MY: {
    continent: 'Asia',
    id: 'MY',
    name: 'Malaysia',
    population: 31381992,
    population_rank: 15,
    region: 'South-Eastern Asia',
  },
  NA: {
    continent: 'Africa',
    id: 'NA',
    name: 'Namibia',
    population: 2484780,
    population_rank: 12,
    region: 'Southern Africa',
  },
  NC: {
    continent: 'Oceania',
    id: 'NC',
    name: 'New Caledonia',
    population: 279070,
    population_rank: 10,
    region: 'Melanesia',
  },
  NE: {
    continent: 'Africa',
    id: 'NE',
    name: 'Niger',
    population: 19245344,
    population_rank: 14,
    region: 'Western Africa',
  },
  NG: {
    continent: 'Africa',
    id: 'NG',
    name: 'Nigeria',
    population: 190632261,
    population_rank: 17,
    region: 'Western Africa',
  },
  NI: {
    continent: 'North America',
    id: 'NI',
    name: 'Nicaragua',
    population: 6025951,
    population_rank: 13,
    region: 'Central America',
  },
  NL: {
    continent: 'Europe',
    id: 'NL',
    name: 'Netherlands',
    population: 17084719,
    population_rank: 14,
    region: 'Western Europe',
  },
  NO: {
    continent: 'Europe',
    id: 'NO',
    name: 'Norway',
    population: 5320045,
    population_rank: 13,
    region: 'Northern Europe',
  },
  NP: {
    continent: 'Asia',
    id: 'NP',
    name: 'Nepal',
    population: 29384297,
    population_rank: 15,
    region: 'Southern Asia',
  },
  NZ: {
    continent: 'Oceania',
    id: 'NZ',
    name: 'New Zealand',
    population: 4510327,
    population_rank: 12,
    region: 'Australia and New Zealand',
  },
  OM: {
    continent: 'Asia',
    id: 'OM',
    name: 'Oman',
    population: 3424386,
    population_rank: 12,
    region: 'Western Asia',
  },
  PK: {
    continent: 'Asia',
    id: 'PK',
    name: 'Pakistan',
    population: 204924861,
    population_rank: 17,
    region: 'Southern Asia',
  },
  PA: {
    continent: 'North America',
    id: 'PA',
    name: 'Panama',
    population: 3753142,
    population_rank: 12,
    region: 'Central America',
  },
  PE: {
    continent: 'South America',
    id: 'PE',
    name: 'Peru',
    population: 31036656,
    population_rank: 15,
    region: 'South America',
  },
  PH: {
    continent: 'Asia',
    id: 'PH',
    name: 'Philippines',
    population: 104256076,
    population_rank: 17,
    region: 'South-Eastern Asia',
  },
  PG: {
    continent: 'Oceania',
    id: 'PG',
    name: 'Papua New Guinea',
    population: 6909701,
    population_rank: 13,
    region: 'Melanesia',
  },
  PL: {
    continent: 'Europe',
    id: 'PL',
    name: 'Poland',
    population: 38476269,
    population_rank: 15,
    region: 'Eastern Europe',
  },
  PR: {
    continent: 'North America',
    id: 'PR',
    name: 'Puerto Rico',
    population: 3351827,
    population_rank: 12,
    region: 'Caribbean',
  },
  KP: {
    continent: 'Asia',
    id: 'KP',
    name: 'North Korea',
    population: 25248140,
    population_rank: 15,
    region: 'Eastern Asia',
  },
  PT: {
    continent: 'Europe',
    id: 'PT',
    name: 'Portugal',
    population: 10839514,
    population_rank: 14,
    region: 'Southern Europe',
  },
  PY: {
    continent: 'South America',
    id: 'PY',
    name: 'Paraguay',
    population: 6943739,
    population_rank: 13,
    region: 'South America',
  },
  PS: {
    continent: 'Asia',
    id: 'PS',
    name: 'Palestine',
    population: 4543126,
    population_rank: 12,
    region: 'Western Asia',
  },
  QA: {
    continent: 'Asia',
    id: 'QA',
    name: 'Qatar',
    population: 2314307,
    population_rank: 12,
    region: 'Western Asia',
  },
  RO: {
    continent: 'Europe',
    id: 'RO',
    name: 'Romania',
    population: 21529967,
    population_rank: 15,
    region: 'Eastern Europe',
  },
  RU: {
    continent: 'Europe',
    id: 'RU',
    name: 'Russia',
    population: 142257519,
    population_rank: 17,
    region: 'Eastern Europe',
  },
  RW: {
    continent: 'Africa',
    id: 'RW',
    name: 'Rwanda',
    population: 11901484,
    population_rank: 14,
    region: 'Eastern Africa',
  },
  EH: {
    continent: 'Africa',
    id: 'EH',
    name: 'W. Sahara',
    population: 603253,
    population_rank: 11,
    region: 'Northern Africa',
  },
  SA: {
    continent: 'Asia',
    id: 'SA',
    name: 'Saudi Arabia',
    population: 28571770,
    population_rank: 15,
    region: 'Western Asia',
  },
  SD: {
    continent: 'Africa',
    id: 'SD',
    name: 'Sudan',
    population: 37345935,
    population_rank: 15,
    region: 'Northern Africa',
  },
  SS: {
    continent: 'Africa',
    id: 'SS',
    name: 'S. Sudan',
    population: 13026129,
    population_rank: 14,
    region: 'Eastern Africa',
  },
  SN: {
    continent: 'Africa',
    id: 'SN',
    name: 'Senegal',
    population: 14668522,
    population_rank: 14,
    region: 'Western Africa',
  },
  SB: {
    continent: 'Oceania',
    id: 'SB',
    name: 'Solomon Is.',
    population: 647581,
    population_rank: 11,
    region: 'Melanesia',
  },
  SL: {
    continent: 'Africa',
    id: 'SL',
    name: 'Sierra Leone',
    population: 6163195,
    population_rank: 13,
    region: 'Western Africa',
  },
  SV: {
    continent: 'North America',
    id: 'SV',
    name: 'El Salvador',
    population: 6172011,
    population_rank: 13,
    region: 'Central America',
  },
  SO: {
    continent: 'Africa',
    id: 'SO',
    name: 'Somalia',
    population: 7531386,
    population_rank: 13,
    region: 'Eastern Africa',
  },
  RS: {
    continent: 'Europe',
    id: 'RS',
    name: 'Serbia',
    population: 7111024,
    population_rank: 13,
    region: 'Southern Europe',
  },
  SR: {
    continent: 'South America',
    id: 'SR',
    name: 'Suriname',
    population: 591919,
    population_rank: 11,
    region: 'South America',
  },
  SK: {
    continent: 'Europe',
    id: 'SK',
    name: 'Slovakia',
    population: 5445829,
    population_rank: 13,
    region: 'Eastern Europe',
  },
  SI: {
    continent: 'Europe',
    id: 'SI',
    name: 'Slovenia',
    population: 1972126,
    population_rank: 12,
    region: 'Southern Europe',
  },
  SE: {
    continent: 'Europe',
    id: 'SE',
    name: 'Sweden',
    population: 9960487,
    population_rank: 13,
    region: 'Northern Europe',
  },
  SZ: {
    continent: 'Africa',
    id: 'SZ',
    name: 'Swaziland',
    population: 1467152,
    population_rank: 12,
    region: 'Southern Africa',
  },
  SY: {
    continent: 'Asia',
    id: 'SY',
    name: 'Syria',
    population: 18028549,
    population_rank: 14,
    region: 'Western Asia',
  },
  TD: {
    continent: 'Africa',
    id: 'TD',
    name: 'Chad',
    population: 12075985,
    population_rank: 14,
    region: 'Middle Africa',
  },
  TG: {
    continent: 'Africa',
    id: 'TG',
    name: 'Togo',
    population: 7965055,
    population_rank: 13,
    region: 'Western Africa',
  },
  TH: {
    continent: 'Asia',
    id: 'TH',
    name: 'Thailand',
    population: 68414135,
    population_rank: 16,
    region: 'South-Eastern Asia',
  },
  TJ: {
    continent: 'Asia',
    id: 'TJ',
    name: 'Tajikistan',
    population: 8468555,
    population_rank: 13,
    region: 'Central Asia',
  },
  TM: {
    continent: 'Asia',
    id: 'TM',
    name: 'Turkmenistan',
    population: 5351277,
    population_rank: 13,
    region: 'Central Asia',
  },
  TL: {
    continent: 'Asia',
    id: 'TL',
    name: 'Timor-Leste',
    population: 1291358,
    population_rank: 12,
    region: 'South-Eastern Asia',
  },
  TT: {
    continent: 'North America',
    id: 'TT',
    name: 'Trinidad and Tobago',
    population: 1218208,
    population_rank: 12,
    region: 'Caribbean',
  },
  TN: {
    continent: 'Africa',
    id: 'TN',
    name: 'Tunisia',
    population: 11403800,
    population_rank: 14,
    region: 'Northern Africa',
  },
  TR: {
    continent: 'Asia',
    id: 'TR',
    name: 'Turkey',
    population: 80845215,
    population_rank: 16,
    region: 'Western Asia',
  },
  TW: {
    continent: 'Asia',
    id: 'TW',
    name: 'Taiwan',
    population: 23508428,
    population_rank: 15,
    region: 'Eastern Asia',
  },
  TZ: {
    continent: 'Africa',
    id: 'TZ',
    name: 'Tanzania',
    population: 53950935,
    population_rank: 16,
    region: 'Eastern Africa',
  },
  UG: {
    continent: 'Africa',
    id: 'UG',
    name: 'Uganda',
    population: 39570125,
    population_rank: 15,
    region: 'Eastern Africa',
  },
  UA: {
    continent: 'Europe',
    id: 'UA',
    name: 'Ukraine',
    population: 44033874,
    population_rank: 15,
    region: 'Eastern Europe',
  },
  UY: {
    continent: 'South America',
    id: 'UY',
    name: 'Uruguay',
    population: 3360148,
    population_rank: 12,
    region: 'South America',
  },
  US: {
    continent: 'North America',
    id: 'US',
    name: 'United States of America',
    population: 326625791,
    population_rank: 17,
    region: 'Northern America',
  },
  UZ: {
    continent: 'Asia',
    id: 'UZ',
    name: 'Uzbekistan',
    population: 29748859,
    population_rank: 15,
    region: 'Central Asia',
  },
  VE: {
    continent: 'South America',
    id: 'VE',
    name: 'Venezuela',
    population: 31304016,
    population_rank: 15,
    region: 'South America',
  },
  VN: {
    continent: 'Asia',
    id: 'VN',
    name: 'Vietnam',
    population: 96160163,
    population_rank: 16,
    region: 'South-Eastern Asia',
  },
  VU: {
    continent: 'Oceania',
    id: 'VU',
    name: 'Vanuatu',
    population: 282814,
    population_rank: 10,
    region: 'Melanesia',
  },
  YE: {
    continent: 'Asia',
    id: 'YE',
    name: 'Yemen',
    population: 28036829,
    population_rank: 15,
    region: 'Western Asia',
  },
  ZA: {
    continent: 'Africa',
    id: 'ZA',
    name: 'South Africa',
    population: 54841552,
    population_rank: 16,
    region: 'Southern Africa',
  },
  ZM: {
    continent: 'Africa',
    id: 'ZM',
    name: 'Zambia',
    population: 15972000,
    population_rank: 14,
    region: 'Eastern Africa',
  },
  ZW: {
    continent: 'Africa',
    id: 'ZW',
    name: 'Zimbabwe',
    population: 13805084,
    population_rank: 14,
    region: 'Eastern Africa',
  },
}
